import React from 'react';

const AccountNumber = (props) => {
    const {
        name        = '',
        value       = '',
        type        = 'text',
        onChange    = (value) => {},
        disabled    = false
    } = props;

    const handleInputChange = (event) => {
        const accountNumber = event.target.value
            .replace(/\D/g, '')
            .slice(0, 8);

        onChange(accountNumber);
    };

    return (
        <input type={'text'}
               value={value}
               onChange={handleInputChange}
               disabled={disabled}
               name={name}
               id={name}
               className={'input-field'}
               autoComplete="off"
        />
    );
}

export default AccountNumber;
